import * as Yup from "yup";

import { PasswordValidation } from "./PasswordValidation";

export const LoginValidationSchema = Yup.object().shape({
  email: Yup.string().required("Email is required").email("Email is Invalid"),
  password: PasswordValidation,
});
